import React from 'react';
import { Route } from 'react-router-dom';

// we insert the CSS here for all routes that use this
// so we can have a different frontend when logged out
import '../assets/scss/dashlite.scss';

const AppRoute = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {

  Layout = (Layout === undefined) ? props => (<>{props.children}</>) : Layout;

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )} />
  );
}

export default AppRoute;